// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetInvoicePdfApiParameter } from "@store/Framework/Services/InvoiceService";
import StoreInvoiceDetailsState from "@store/Framework/Store/Store/Pages/InvoiceDetails/InvoiceDetailsState";
import { Draft } from "immer";

const initialState: StoreInvoiceDetailsState = {
    invoicesLoading: [],
    isLoadingInvoice: false,
};

const actions = {
    "Store/Pages/InvoiceDetails/BeginDownload": (
        draft: Draft<StoreInvoiceDetailsState>,
        action: GetInvoicePdfApiParameter,
    ) => {
        draft.invoicesLoading.push(action.invoiceNumber);
        draft.isLoadingInvoice = true;
    },
    "Store/Pages/InvoiceDetails/CompleteDownload": (
        draft: Draft<StoreInvoiceDetailsState>,
        action: GetInvoicePdfApiParameter,
    ) => {
        draft.invoicesLoading = draft.invoicesLoading.filter(x => x !== action.invoiceNumber);
        draft.isLoadingInvoice = draft.invoicesLoading.length > 0;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreInvoiceDetailsActions = Parameters<typeof reducer>[1];
export default reducer;
